"use strict";

var _classCallCheck = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _get = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _getPrototypeOf = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PolylineSelector = void 0;

var Point2D_1 = require("../../Core/Point2D");

var RegionData_1 = require("../../Core/RegionData");

var CrossElement_1 = require("../Component/CrossElement");

var Selector_1 = require("./Selector");
/**
 * The selector to define a polyline-region.
 */


var PolylineSelector = /*#__PURE__*/function (_Selector_1$Selector) {
  _inherits(PolylineSelector, _Selector_1$Selector);

  /**
   * Creates new `PolylineSelector` object.
   * @param parent - The parent SVG-element.
   * @param paper - The `Snap.Paper` element to draw on.
   * @param boundRect - The bounding box.
   * @param callbacks - The collection of callbacks.
   */
  function PolylineSelector(parent, paper, boundRect, callbacks) {
    var _this;

    _classCallCheck(this, PolylineSelector);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PolylineSelector).call(this, parent, paper, boundRect, callbacks));
    /**
     * Current state of selector.
     */

    _this.isCapturing = false;

    _this.buildUIElements();

    _this.reset();

    _this.hide();

    return _this;
  }
  /**
   * Resizes the selector to specified `width` and `height`.
   * @param width - The new `width`.
   * @param height - The new `height`.
   */


  _createClass(PolylineSelector, [{
    key: "resize",
    value: function resize(width, height) {
      _get(_getPrototypeOf(PolylineSelector.prototype), "resize", this).call(this, width, height);

      this.crossA.resize(width, height);
    }
    /**
     * Hides the selector.
     */

  }, {
    key: "hide",
    value: function hide() {
      _get(_getPrototypeOf(PolylineSelector.prototype), "hide", this).call(this);

      this.crossA.hide();
      this.nextPoint.node.setAttribute("visibility", "hidden");
      this.nextSegment.node.setAttribute("visibility", "hidden");
      this.polyline.node.setAttribute("visibility", "hidden");
      this.pointsGroup.node.setAttribute("visibility", "hidden");
    }
    /**
     * Shows the selector.
     */

  }, {
    key: "show",
    value: function show() {
      _get(_getPrototypeOf(PolylineSelector.prototype), "show", this).call(this);

      this.crossA.show();
      this.nextPoint.node.setAttribute("visibility", "visible");
      this.nextSegment.node.setAttribute("visibility", "visible");
      this.polyline.node.setAttribute("visibility", "visible");
      this.pointsGroup.node.setAttribute("visibility", "visible");
    }
    /**
     * Disables and hides this selector.
     */

  }, {
    key: "disable",
    value: function disable() {
      this.reset();

      _get(_getPrototypeOf(PolylineSelector.prototype), "disable", this).call(this);
    }
    /**
     * Builds selector's UI.
     */

  }, {
    key: "buildUIElements",
    value: function buildUIElements() {
      this.node = this.paper.g();
      this.node.addClass("polylineSelector");
      this.crossA = new CrossElement_1.CrossElement(this.paper, this.boundRect);
      this.nextPoint = this.paper.circle(0, 0, PolylineSelector.DEFAULT_SELECTOR_RADIUS);
      this.nextPoint.addClass("nextPointStyle");
      this.nextSegment = this.paper.line(0, 0, 0, 0);
      this.nextSegment.addClass("nextSegmentStyle");
      this.pointsGroup = this.paper.g();
      this.pointsGroup.addClass("polylineGroupStyle");
      this.polyline = this.paper.polyline([]);
      this.polyline.addClass("polylineStyle");
      this.node.add(this.polyline);
      this.node.add(this.pointsGroup);
      this.node.add(this.crossA.node);
      this.node.add(this.nextSegment);
      this.node.add(this.nextPoint);
      var listeners = [{
        event: "pointerenter",
        listener: this.onPointerEnter,
        base: this.parentNode,
        bypass: false
      }, {
        event: "pointerleave",
        listener: this.onPointerLeave,
        base: this.parentNode,
        bypass: false
      }, {
        event: "pointerdown",
        listener: this.onPointerDown,
        base: this.parentNode,
        bypass: false
      }, {
        event: "click",
        listener: this.onClick,
        base: this.parentNode,
        bypass: false
      }, {
        event: "pointermove",
        listener: this.onPointerMove,
        base: this.parentNode,
        bypass: false
      }, {
        event: "dblclick",
        listener: this.onDoubleClick,
        base: this.parentNode,
        bypass: false
      }, {
        event: "keyup",
        listener: this.onKeyUp,
        base: window,
        bypass: true
      }];
      this.subscribeToEvents(listeners);
    }
    /**
     * Resets the selector.
     */

  }, {
    key: "reset",
    value: function reset() {
      this.points = new Array();
      this.lastPoint = null;
      var ps = this.pointsGroup.children();

      while (ps.length > 0) {
        ps[0].remove();
        ps = this.pointsGroup.children();
      }

      this.polyline.attr({
        points: ""
      });

      if (this.isCapturing) {
        this.isCapturing = false;
      }
    }
    /**
     * Adds a new point to polyline at specified coordinates
     * @param x - x-coordinate of the new point.
     * @param y - y-coordinate of the new point.
     */

  }, {
    key: "addPoint",
    value: function addPoint(x, y) {
      this.points.push(new Point2D_1.Point2D(x, y));
      var point = this.paper.circle(x, y, PolylineSelector.DEFAULT_POINT_RADIUS);
      point.addClass("polylinePointStyle");
      this.pointsGroup.add(point);
      var pointsStr = "";
      this.points.forEach(function (p) {
        pointsStr += "".concat(p.x, ",").concat(p.y, ",");
      });
      this.polyline.attr({
        points: pointsStr.substr(0, pointsStr.length - 1)
      });
    }
    /**
     * Listener for the pointer enter event.
     * @param e PointerEvent
     */

  }, {
    key: "onPointerEnter",
    value: function onPointerEnter(e) {
      var _this2 = this;

      window.requestAnimationFrame(function () {
        _this2.show();
      });
    }
    /**
     * Listener for the pointer leave event.
     * @param e PointerEvent
     */

  }, {
    key: "onPointerLeave",
    value: function onPointerLeave(e) {
      var _this3 = this;

      if (!this.isCapturing) {
        window.requestAnimationFrame(function () {
          _this3.hide();
        });
      } else {
        var rect = this.parentNode.getClientRects();
        var p = new Point2D_1.Point2D(e.clientX - rect[0].left, e.clientY - rect[0].top);
        this.moveCross(this.crossA, p);
        this.movePoint(this.nextPoint, p);
      }
    }
    /**
     * Listener for the pointer down event.
     * @param e PointerEvent
     */

  }, {
    key: "onPointerDown",
    value: function onPointerDown(e) {
      if (!this.isCapturing) {
        this.isCapturing = true;

        if (typeof this.callbacks.onSelectionBegin === "function") {
          this.callbacks.onSelectionBegin();
        }
      }
    }
    /**
     * Listener for the mouse click event.
     * @param e MouseEvent
     */

  }, {
    key: "onClick",
    value: function onClick(e) {
      var _this4 = this;

      if (e.detail <= 1) {
        window.requestAnimationFrame(function () {
          var p = new Point2D_1.Point2D(_this4.crossA.x, _this4.crossA.y);

          _this4.addPoint(p.x, p.y);

          _this4.lastPoint = p;
        });
      }
    }
    /**
     * Listener for the pointer move event.
     * @param e PointerEvent
     */

  }, {
    key: "onPointerMove",
    value: function onPointerMove(e) {
      var _this5 = this;

      window.requestAnimationFrame(function () {
        var rect = _this5.parentNode.getClientRects();

        var p = new Point2D_1.Point2D(e.clientX - rect[0].left, e.clientY - rect[0].top);

        _this5.show();

        _this5.moveCross(_this5.crossA, p);

        _this5.movePoint(_this5.nextPoint, p);

        if (_this5.lastPoint != null) {
          _this5.moveLine(_this5.nextSegment, _this5.lastPoint, p);
        } else {
          _this5.moveLine(_this5.nextSegment, p, p);
        }
      });
      e.preventDefault();
    }
    /**
     * Listener for the mouse double click event.
     * @param e MouseEvent
     */

  }, {
    key: "onDoubleClick",
    value: function onDoubleClick(e) {
      this.submitPolyline();
    }
    /**
     * Submits the new polygon region to the callback function.
     */

  }, {
    key: "submitPolyline",
    value: function submitPolyline() {
      if (typeof this.callbacks.onSelectionEnd === "function") {
        var box = this.polyline.getBBox();
        this.callbacks.onSelectionEnd(new RegionData_1.RegionData(box.x, box.y, box.width, box.height, this.getPolylinePoints(), RegionData_1.RegionDataType.Polyline));
      }

      this.reset();
    }
    /**
     * Returns the polyline points, closes it if required.
     * @param close - A flag to "close" the polyline if last point is near to the first one.
     * @param threshold - The threshold to calculate what is "near".
     */

  }, {
    key: "getPolylinePoints",
    value: function getPolylinePoints() {
      var close = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var threshold = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;
      var points = this.points.map(function (p) {
        return p.copy();
      });

      if (points.length >= 3 && close) {
        var fp = points[0];
        var lp = points[points.length - 1];
        var distanceSquare = (fp.x - lp.x) * (fp.x - lp.x) + (fp.y - lp.y) * (fp.y - lp.y);

        if (distanceSquare <= threshold * threshold) {
          points[points.length - 1] = fp.copy();
        }
      }

      return points;
    }
    /**
     * Listener for the key up event.
     * @param e KeyboardEvent
     */

  }, {
    key: "onKeyUp",
    value: function onKeyUp(e) {
      // Holding shift key enable square drawing mode
      if (e.code === "Escape") {
        this.submitPolyline();
      }
    }
  }]);

  return PolylineSelector;
}(Selector_1.Selector);

exports.PolylineSelector = PolylineSelector;
/**
 * Default radius for the point element. Can be redefined through css styles.
 */

PolylineSelector.DEFAULT_POINT_RADIUS = 3;
/**
 * Default radius for the point element. Can be redefined through css styles.
 */

PolylineSelector.DEFAULT_SELECTOR_RADIUS = 6;